import {ColumnTypeEnumeration} from './column-type.enumeration';
import {AlignColumnsEnumeration} from './align-columns.enumeration';

const FILTER_SUFFIX = 'Filter';

export class DatatableColumn {
  name: string;
  filterName: string;
  label: string;
  visible = true;
  sortable = true;
  searchable = false;
  type: ColumnTypeEnumeration;
  alignment: AlignColumnsEnumeration;

  constructor(name: string, label: string, searchable?: boolean, type?: ColumnTypeEnumeration, alignment?: AlignColumnsEnumeration) {
    this.name = name;
    this.filterName = name + FILTER_SUFFIX;
    this.label = label;
    this.visible = true;
    this.sortable = true;
    this.searchable = searchable;
    this.type = type ? type : ColumnTypeEnumeration.TEXT_COLUMN;
    this.alignment = alignment ? alignment : AlignColumnsEnumeration.ALIGN_LEFT;
  }
}
